export default "__VITE_ASSET__BFsAm9Yk__"